import { AbstractControl, ValidatorFn } from '@angular/forms';

export function emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        // Пустое значение допустимо — поле необязательное (обязательность задаётся
        // отдельно через Validators.required). Валидируем только формат непустого email.
        if (control.value === null || control.value === undefined || control.value === '') {
            return null;
        }

        const regexPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

        const valid = regexPattern.test(control.value);
        return valid ? null : { invalidEmail: { value: control.value } };
    };
}
